import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Grid,
  Box,
  useTheme,
  InputAdornment,
  Button,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Field,
  reduxForm,
  getFormSyncErrors,
  getFormValues,
  change,
} from "redux-form";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";

import { Edit } from "@mui/icons-material";
import {
  renderTextField,
  renderSelectField,
} from "components/FormFields/FieldTypes";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneValidator } from "components/FormFields/normalizers";
import {
  emailValidator,
  onlyNumbers,
  zip,
} from "components/FormFields/validators";
import { homeActions } from "actions";
import ProfileInsuranceContainer from "./ProfileInsuranceContainer";
import SuccessErrorMessagePopUp from "pages/SearchMedication/SuccessErrorMessagePopUp";
import { gaugeService } from "services";
import heartIcon from "assets/images/heartIcon/heart-30.png";
import heartFilledIcon from "assets/images/heartIcon/heart-filled-30.png";

const Profile = (props) => {
  const theme = useTheme();
  const {
    formErrors,
    formValues,
    getProfile,
    profileInfo,
    initialize,
    saveProfile,
    getSearchRadius,
    searchRadius,
    change,
    saveProfileInfo,
    saveUserInsurance,
    getCityStateForZipCode,
    zipDataStatus,
    zipData,
    zipErrorMessage,
    resetZipStatus,
    getInsuranceDetail,
    insuranceInfo,
    resetSaveProfile,
    updateGTMDataLayer,
    gtmInfo,
    saveInsuranceData,
  } = props;
  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );
  const [selctedProfileInsurance, setSelctedProfileInsurance] =
    useState(storedInsuranceData);
  const [showZipcodeError, setShowZipcodeError] = useState(false);

  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [successErrorTitle] = useState("Update Profile");
  const [successErrorMessage, setSuccessErrorMessage] = useState("");
  const [showSuccessErrorDialog, setShowSuccessErrorDialog] = useState(false);

  const [pharmacyList, setPharmacyList] = useState([]);
  const [favPharmacy, setFavPharmacy] = useState(null);
  const [openPharmacyInfoDialog, setOpenPharmacyInfoDialog] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  useEffect(() => {
    getSearchRadius();
    getProfile();
    document.getElementById("appcontent").scroll(0, 0);

    updateGTMDataLayer({
      page: "Global",
      screen: "Profile",
      screen_title: "Global",
      event: "Nav_profile",
    });
    return () => {
      updateGTMDataLayer({
        screen_referrer: "Profile",
        page: "Global",
        screen: "Profile",
        screen_title: "Global",
        event: "Nav_profile",
      });
      resetSaveProfile();
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  const getPharmacyList = async (zipCode, mileRadius) => {
    const pharmacyArray = await gaugeService.getPharmacyGroupSearchByMiles(
      zipCode,
      mileRadius
    );
    setPharmacyList(pharmacyArray.data);
  };

  const getPharmacyData = async (pharmacyGroupId) => {
    const data = await gaugeService.getPharmacyDataByLocationId(
      pharmacyGroupId
    );
    if (data.data) {
      let obj = {
        ...data.data,
        pharmacyGroupId: data.data.pharmacyGroupId,
        pharmacyLocationId: data.data.id,
      };
      setFavPharmacy(obj);
    }
  };

  useEffect(() => {
    if (profileInfo && Object.keys(profileInfo).length && searchRadius.length) {
      const { data } = profileInfo;
      const defaultRadius = searchRadius.filter((word) => word.default);
      const mileRadius = data.mileRadius
        ? data.mileRadius
        : defaultRadius?.length
        ? defaultRadius[0].value
        : searchRadius[0].value;

      if (data?.pharmacyLocationId) {
        getPharmacyData(data?.pharmacyLocationId);
      }
      getPharmacyList(data.zipCode, mileRadius);
      if (data?.insuranceId) {
        getInsuranceDetail(data?.insuranceId);
      }
      initialize({
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone,
        email: data.email,
        zipCode: data.zipCode,
        password: "******",
        insuranceName:
          insuranceInfo?.name ||
          (selctedProfileInsurance && selctedProfileInsurance.name),
        bin: data.bin,
        groupNum: data.groupNum,
        mileRadius: data.mileRadius
          ? data.mileRadius
          : defaultRadius?.length
          ? defaultRadius[0].value
          : searchRadius[0].value,
      });
    } else {
      const { data } = profileInfo;
      if (
        data &&
        Object.keys(data).length &&
        (data?.insuranceId || selctedProfileInsurance?.id)
      ) {
        getInsuranceDetail(data?.insuranceId || selctedProfileInsurance?.id);
      }
    }
  }, [profileInfo, searchRadius]);

  useEffect(() => {
    if (insuranceInfo?.name) {
      saveInsuranceData(insuranceInfo);
      setSelctedProfileInsurance(insuranceInfo);
      initialize({
        ...formValues,
        insuranceName: insuranceInfo?.name,
      });
    }
  }, [insuranceInfo]);

  useEffect(() => {
    if (saveProfileInfo && saveProfileInfo?.success) {
      setSuccessErrorMessage(saveProfileInfo?.message);
      setShowSuccessErrorDialog(true);
    } else if (
      saveProfileInfo &&
      Object.keys(saveProfileInfo).length &&
      !saveProfileInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(saveProfileInfo?.message);
    }
  }, [saveProfileInfo]);

  useEffect(() => {
    if (!zipDataStatus) {
      setShowZipcodeError(true);
    }
  }, [zipDataStatus]);

  const onFormSubmit = () => {
    const { data } = profileInfo;
    const paramsData = formValues;
    paramsData["id"] = data?.id || "";
    paramsData["insuranceId"] = selctedProfileInsurance.id;
    if (favPharmacy?.id) {
      paramsData["pharmacyLocationId"] = favPharmacy?.id;
    }
    if (favPharmacy?.pharmacyGroupId) {
      paramsData["pharmacyGroupId"] = favPharmacy?.pharmacyGroupId;
    }
    saveProfile(paramsData);
  };

  const zipSearch = (event) => {
    if (event?.target?.value && event.target.value.length === 5) {
      getCityStateForZipCode(event.target.value);
    }
  };

  return (
    <SecondaryCenterTemplate
      pageTitle="Profile"
      marginBottom={0}
      paddingBottom={0}
      minHeight="40px"
    >
      <Grid container>
        <Grid item xs={12} sm={8} sx={{ margin: "auto" }}>
          <form>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="firstName"
                  component={renderTextField}
                  label="First Name"
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="lastName"
                  component={renderTextField}
                  label="Last Name"
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="phone"
                  component={renderTextField}
                  label="Mobile Phone Number"
                  disabled={true}
                  format={phoneFormatter}
                  normalize={phoneValidator}
                  endIcon={
                    <InputAdornment
                      position="end"
                      component={Link}
                      to="/ChangePhoneNumber"
                    >
                      <Edit sx={{ color: theme.palette.secondary.main }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="email"
                  disabled={true}
                  component={renderTextField}
                  label="Email Address"
                  validate={[emailValidator]}
                  endIcon={
                    <InputAdornment
                      position="end"
                      component={Link}
                      to="/ChangeEmailAddress"
                    >
                      <Edit sx={{ color: theme.palette.secondary.main }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="password"
                  component={renderTextField}
                  label="Password"
                  disabled={true}
                  type="password"
                  endIcon={
                    <InputAdornment
                      position="end"
                      component={Link}
                      to="/ChangePassword"
                    >
                      <Edit sx={{ color: theme.palette.secondary.main }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <Field
                  name="insuranceName"
                  component={renderTextField}
                  label="Insurance"
                  disabled={true}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => setOpenInfoDialog(true)}
                    >
                      <Edit sx={{ color: theme.palette.secondary.main }} />
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} pb={4} pt={0}>
                <Field
                  name="bin"
                  component={renderTextField}
                  label="BIN"
                  validate={[onlyNumbers]}
                />
              </Grid>
              <Grid item xs={12} sm={6} pb={4} pt={0}>
                <Field
                  name="groupNum"
                  component={renderTextField}
                  label="Group Number"
                  validate={[onlyNumbers]}
                />
              </Grid>
              <Grid item xs={12} sm={6} pb={4} pt={0}>
                <Field
                  name="zipCode"
                  component={renderTextField}
                  onChange={zipSearch}
                  label="Zip Code"
                  validate={[zip]}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  name="mileRadius"
                  component={renderSelectField}
                  label="Search Radius"
                  options={searchRadius}
                  onChange={(event, value) => {
                    const zipCode =
                      zipData?.zipCode || profileInfo.data.zipCode;
                    if (value) {
                      getPharmacyList(zipCode, value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} pb={4} pt={0}>
                <div
                  style={{
                    display: "flex",
                    fontSize: "16px",
                    fontFamily: "Lato-Medium",
                    color: "#607277",
                  }}
                >
                  Favorite Pharmacy
                </div>
                <div>
                  <List
                    sx={{
                      border: `solid 2px ${theme.palette.common.greenThree}`,
                      marginTop: "5px",
                    }}
                    key={favPharmacy?.id}
                  >
                    {favPharmacy ? (
                      <>
                        <ListItem style={{ cursor: "pointer" }}>
                          <ListItemText
                            primary={
                              !favPharmacy.logoUrl && !favPharmacy.logoURL ? (
                                favPharmacy.pharmacyName
                              ) : (
                                <img
                                  style={{
                                    width: matchesMinWidth ? "50%" : "40%",
                                  }}
                                  src={
                                    favPharmacy.logoUrl || favPharmacy.logoURL
                                  }
                                  alt="logo"
                                />
                              )
                            }
                            primaryTypographyProps={{
                              fontSize: matchesMinWidth ? "14px" : "16px",
                              color: theme.palette.primary.main,
                              textTransform: "none",
                              fontFamily: "Lato-Bold",
                            }}
                          />
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Box
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <Edit
                                onClick={() => {
                                  setOpenPharmacyInfoDialog(true);
                                }}
                                sx={{ color: theme.palette.secondary.main }}
                              />
                            </Box>
                          </Box>
                        </ListItem>
                        {favPharmacy?.distance > 0 && (
                          <Typography
                            variant="h4LatoMedium"
                            component="div"
                            sx={{
                              color: "#003d4c",
                              paddingLeft: "4%",
                              margin: "0%",
                              marginBottom: "2%",
                              display: "flex",
                            }}
                          >
                            {`${favPharmacy?.distance?.toFixed(2)} mi `}
                          </Typography>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          color: "#003d4c",
                          fontSize: "20px",
                          display: "flex",
                          padding: "1%",
                          justifyContent: "space-between",
                          fontFamily: "Lato-Semibold",
                        }}
                      >
                        <div> No Favorite Pharmacy </div>

                        <Edit
                          onClick={() => {
                            setOpenPharmacyInfoDialog(true);
                          }}
                          sx={{ color: theme.palette.secondary.main }}
                        />
                      </div>
                    )}
                  </List>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{ margin: "auto", textAlign: "center" }}
              >
                <Box mt={5} mb={2}>
                  <Button
                    variant="large"
                    type="button"
                    onClick={onFormSubmit}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      minWidth: "100%",
                      backgroundColor:
                        formErrors && Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        formErrors && Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    Save Changes
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
          {openPharmacyInfoDialog ? (
            <Dialog
              open={openPharmacyInfoDialog}
              onClose={() => setOpenPharmacyInfoDialog(false)}
              fullWidth
              maxWidth="sm"
              className="app-dialog"
              style={{ height: "90vh", textAlign: "center" }}
            >
              <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h2LatoBlackNew"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "95%",
                    //color: "#03952a",
                    fontSize: matchesMinWidth ? "16px" : "24px",
                    justifyContent: "center",
                  }}
                >
                  Pick your favorite pharmacy
                </Typography>
                <Typography
                  variant="h2LatoBlack"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    lineHeight: "1",
                    fontSize: matchesMinWidth ? "10px" : "24px",
                  }}
                  onClick={() => {
                    setOpenPharmacyInfoDialog(false);
                  }}
                >
                  <CloseIcon />
                </Typography>
              </DialogTitle>
              <DialogContent sx={{ padding: "10px" }}>
                <div
                  style={{
                    height: matchesMinWidth ? "300px" : "500px",
                    overflow: "scroll",
                  }}
                >
                  <Divider />
                  {pharmacyList.map((data) => (
                    <List
                      sx={{ paddingTop: "0px", paddingBottom: "0px" }}
                      key={data?.id}
                    >
                      <ListItem
                        onClick={() => {
                          let obj = {
                            ...data,
                            pharmacyGroupId: data.id,
                            pharmacyLocationId: data.pharmacyLocationId,
                          };
                          setFavPharmacy(obj);
                          setOpenPharmacyInfoDialog(false);
                        }}
                        style={{
                          cursor: "pointer",
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }}
                      >
                        <ListItemText
                          primary={
                            !data.logoURL ? (
                              data.name
                            ) : (
                              <img
                                style={{
                                  width: matchesMinWidth ? "50%" : "40%",
                                  height: matchesMinWidth ? "50px" : "70px",
                                }}
                                src={data.logoURL}
                                alt="logo"
                              />
                            )
                          }
                          primaryTypographyProps={{
                            fontSize: matchesMinWidth ? "14px" : "16px",
                            color: theme.palette.primary.main,
                            textTransform: "none",
                            fontFamily: "Lato-Bold",
                          }}
                        />
                        <Box style={{ display: "flex", alignItems: "center" }}>
                          <Box
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            {favPharmacy?.pharmacyLocationId ===
                            data.pharmacyLocationId ? (
                              <img
                                className="fav-heart-icon"
                                src={heartFilledIcon}
                                alt="favIcon"
                              />
                            ) : (
                              <img
                                className="fav-heart-icon"
                                src={heartIcon}
                                alt="favIcon"
                              />
                            )}
                          </Box>
                        </Box>
                      </ListItem>
                      {data?.pharmacyType !== "M" && (
                      <Typography
                        variant="h4LatoMedium"
                        component="div"
                        sx={{
                          color: "#003d4c",
                          paddingLeft: "4%",
                          margin: "0%",
                          marginBottom: "2%",
                          display: "flex",
                        }}
                      >
                        {`${data?.distance?.toFixed(2)}mi `}
                      </Typography>
                      )}
                      <Divider />
                    </List>
                  ))}
                </div>
              </DialogContent>
            </Dialog>
          ) : null}

          {openInfoDialog ? (
            <Dialog
              open={openInfoDialog}
              onClose={() => setOpenInfoDialog(false)}
              fullWidth
              maxWidth="sm"
              className="app-dialog"
              style={{ height: "90vh", textAlign: "center" }}
            >
              <DialogContent sx={{ padding: "40px" }}>
                <ProfileInsuranceContainer
                  onSelectInsurance={(value) => {
                    setSelctedProfileInsurance(value);
                    change("insuranceName", value.name);
                    setOpenInfoDialog(false);
                    saveUserInsurance(value.id);
                  }}
                  setOpenInfoDialog={setOpenInfoDialog}
                />
              </DialogContent>
            </Dialog>
          ) : null}
          {showSuccessErrorDialog ? (
            <SuccessErrorMessagePopUp
              showPopUp={showSuccessErrorDialog}
              message={successErrorMessage}
              title={successErrorTitle}
              onDoneClick={() => {
                // resetPasswordChange();
                setShowSuccessErrorDialog(false);
              }}
            />
          ) : null}
          {showZipcodeError ? (
            <Dialog open={showZipcodeError} className="info-dialog">
              <DialogContent sx={{ padding: "40px" }}>
                <Box mt={2}>
                  <Typography variant="text4">{zipErrorMessage}</Typography>
                </Box>
                <Box mt={3} mb={1}>
                  <Button
                    sx={{ width: 100 }}
                    variant="filled"
                    onClick={() => {
                      change("insuranceName", "");
                      setShowZipcodeError(false);
                      resetZipStatus();
                    }}
                  >
                    OK
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
          ) : null}
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("PROFILE_FORM")(state) || {},
    formValues: getFormValues("PROFILE_FORM")(state),
    profileInfo: state.profile.profileData || {},
    saveProfileInfo: state.profile.saveProfileInfo,
    zipErrorMessage: state.zipData.message,
    zipDataStatus: state.zipData.zipDataStatus,
    zipData: state.zipData.data,
    searchRadius: state.searchRadius.data,
    gtmInfo: state.gtmInfo.data,
    insuranceInfo: state.insuranceInfo.data,
  };
};

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  saveProfile: (params) => homeActions.saveProfile(params),
  getSearchRadius: (params) => homeActions.searchRadius(params),
  getCityStateForZipCode: (value) => homeActions.getCityStateForZipCode(value),
  saveUserInsurance: (value) => homeActions.saveUserInsurance(value),
  resetZipStatus: () => homeActions.resetZipStatus(),
  getInsuranceDetail: (id) => homeActions.getInsuranceDetail(id),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  resetSaveProfile: () => homeActions.resetSaveProfile(),
  change,

  saveInsuranceData: (value) => homeActions.saveInsuranceData(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "PROFILE_FORM",
  })(Profile)
);
